import { computed } from "vue";

export const formatActives = (value) => {
	try {
		return JSON.parse(value).join(", ");
	} catch {
		return Array.isArray(value) ? value.join(", ") : value;
	}
};

export const formatValue = (property) => {
	return computed(() => {
		if (!property || !property.value) return "-";
		if (property.field.type === "DateField") {
			// Remove the T and time part from the string
			return property.value.split("T")?.[0];
		} else if (property.field.type === "DatetimeField") {
			// Don't show T + removed seconds
			return property.value.split("T")?.[0] + " " + property.value.split("T")?.[1]?.replace(/:00$/, "");
		}
		return property.value;
	}).value;
};